import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  PostWebV1UpdateConfigPageApiReq,
  PostWebV1UpdateConfigPageApiRes,
} from './index.d';

/**
 * 更新配置 — 分页列表
 * @see https://yapi.baibu.la/project/996/interface/api/73216
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/update-config/page
 * @更新时间: 2021-04-26 16:15:52
 */
export const postWebV1UpdateConfigPageApi = (data: PostWebV1UpdateConfigPageApiReq) => {
  return http.post<PostWebV1UpdateConfigPageApiRes>({
    url: '/manage-app/web/v1/update-config/page',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
